import { useIntl } from 'react-intl';
import {
  CONSECUTIVE_FAILURES_DESCRIPTION,
  CONSECUTIVE_FAILURES_LABEL,
} from '@/helpers/claimStates';

interface ClaimAttemptCountProps {
  count: number;
  className?: string;
}

export const ClaimAttemptCount = ({
  count,
  className,
}: ClaimAttemptCountProps) => {
  const { formatMessage } = useIntl();

  if (count <= 0) return null;

  const description = formatMessage(CONSECUTIVE_FAILURES_DESCRIPTION);

  return (
    <span className={className} title={description}>
      <span>{formatMessage(CONSECUTIVE_FAILURES_LABEL, { count })}</span>
      <span className="sr-only">. {description}</span>
    </span>
  );
};
